export const reportParameterOptions = [
    {
        value: 'paramReportingPeriod',
        label: 'Reporting Period',
    },
    {
        value: 'paramOrganisationUnit',
        label: 'Organisation Unit',
    },
]



// WEBPACK FOOTER //
// ./src/config/standardReport.js